import { cretechatGptModesStateStore } from "~/solidJs/entities/ChatGptEntities/ChatGptMainLayout";

export const ChatGptStore = cretechatGptModesStateStore();
